// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spofaq-searchapp[data-v-35c8c7b7]{position:relative}", ""]);
// Exports
module.exports = exports;
